import { useEffect, useRef, useState } from 'react'
import { type Lang, useI18n } from '../i18n'
import { Icon } from '../ui/Icon'
import { displayNick, type RoomClient, type RoomState } from './client'

export function Chat({ client, state }: { client: RoomClient; state: RoomState }) {
  const { t, lang } = useI18n()
  const [text, setText] = useState('')
  const listRef = useRef<HTMLOListElement>(null)
  const stick = useRef(true)

  useEffect(() => {
    const el = listRef.current
    if (el && stick.current) el.scrollTop = el.scrollHeight
  }, [state.feed])

  const send = (e: React.FormEvent) => {
    e.preventDefault()
    const msg = text.trim()
    if (!msg) return
    client.send({ t: 'chat', text: msg })
    setText('')
    stick.current = true
  }

  return (
    <div className="chat">
      <ol
        className="chat__list"
        ref={listRef}
        onScroll={(e) => {
          const el = e.currentTarget
          stick.current = el.scrollHeight - el.scrollTop - el.clientHeight < 40
        }}
      >
        {state.feed.length === 0 && <li className="chat__empty">{t('chat.empty')}</li>}
        {state.feed.map((item) =>
          item.kind === 'chat' ? (
            <li key={item.key} className={`chat__msg${item.msg.userId === state.you?.userId ? ' chat__msg--mine' : ''}`}>
              <span className="chat__nick">{displayNick(item.msg.nick)}</span>
              <span className="chat__text">{item.msg.text}</span>
              <time className="chat__time">{clock(item.msg.ts, lang)}</time>
            </li>
          ) : (
            <li key={item.key} className="chat__event">
              {t(item.text.key, item.text.vars)}
            </li>
          ),
        )}
      </ol>
      <form className="chat__form" onSubmit={send}>
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          maxLength={500}
          placeholder={t('chat.placeholder')}
          aria-label={t('chat.placeholder')}
        />
        <button type="submit" className="icon-btn" aria-label={t('chat.send')} disabled={!text.trim()}>
          <Icon name="send" />
        </button>
      </form>
    </div>
  )
}

function clock(ts: number, lang: Lang) {
  return new Date(ts).toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit' })
}
